export const AdminTokenMetricStates = Object.freeze({
    Neutral: 'neutral',
    Positive: 'positive',
    Negative: 'negative'
});

export type AdminTokenMetricState = (typeof AdminTokenMetricStates)[keyof typeof AdminTokenMetricStates];
